export const DELIVERY_STATUS_SCHEDULED = 'scheduled';
export const DELIVERY_STATUS_PREPARED = 'prepared';
export const DELIVERY_STATUS_READY = 'ready';
export const DELIVERY_STATUS_ON_THE_WAY = 'onTheWay';

export const deliveryStatuses = [
  DELIVERY_STATUS_SCHEDULED,
  DELIVERY_STATUS_PREPARED,
  DELIVERY_STATUS_READY,
  DELIVERY_STATUS_ON_THE_WAY,
];
